import { createVanIconComponent } from "./van"

const RefundOutlined = createVanIconComponent("refund-o")
export default RefundOutlined
